<template>  
  <div>
    <q-card v-if="openWork">
      <q-card-title>
        <p>{{$t('global.EditWork')}}</p>
      </q-card-title>
      <q-card-main>
        <p v-if="openWork.IdWorkAssign != null" class="text-weight-bold">{{openWork.GeoRegionDescription}}, {{ openWork.WorkDescription}}</p>
        <div v-if="openWork.IdWorkAssign == null">       
          <q-select
            v-model="selectGeofence"
            float-label="Geo Region Selektieren"
            :options="selectOptions"       
          />
          <q-select
            v-model="selectProduct"
            :float-label="$t('global.Product')"
            :options="optionsProduct"  
            ref="selProducts" 
          />  
          <q-select
            v-model="selectWork"
            float-label="Arbeit Selektieren"
            :options="selectWorkOptions"       
          />
        </div>
        <q-datetime v-model="Starting" type="datetime" :float-label="$t('global.WorkStart')" format-model="string" format="D.MMM.YYYY HH:mm" />
        <q-datetime v-model="Ending" type="datetime" :float-label="$t('global.WorkEnd')" format-model="string" format="D.MMM.YYYY HH:mm" />
        <p class="timer text-weight-bold">{{ timeElapsed }}</p>
        <q-input class="comment" v-model="openWork.Comment" rows="2" :float-label="$t('global.Comment')" type="textarea" />
        <p></p>
        <div v-if="openWork.FlexCost">
          <q-input v-model="openWork.FlexCost" type="number" mask="#.##" stack-label="Flex Kosten" />
          <q-card-separator/>
        </div>
        <p></p>
         <q-btn @click="WorkUpdate()" color="primary" :label="$t('global.Save')" />
      </q-card-main>
    </q-card>  
  </div>
</template>

<script>
import { date } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialogEditWork',
  data () {
    return {
      form: {
        SessionId: null
      },
      openWork: null,
      Starting: null,
      Ending: null,
      selectOptions: [],
      selectGeofence: null,
      selectWorkOptions: [],
      selectWork: null,
      selectProduct: 0,
      optionsProduct: [],
    }
  },
  props: ['IdWork'],
  methods: {
    dateFormat(val) {
      return date.formatDate(val, this.$store.state.session.DateTimeFormat)
    },

    WorkUpdate () {
      this.form.IdWork = this.IdWork
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = 'WorkUpdate'
      this.form.Starting = this.Starting
      this.form.Ending = this.Ending
      this.form.Comment = this.openWork.Comment
      this.form.Assigned = true
      this.form.IdProduct = 0
      this.form.FlexCost = this.openWork.FlexCost
      
      if(this.openWork.IdWorkAssign == null){
        this.form.Assigned = false
        this.form.IdResource = this.selectWork
        this.form.IdGeoRegion = this.selectGeofence
        if(this.selectProduct != null)
          this.form.IdProduct = this.selectProduct
      }

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
            this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
            eventBus.$emit('workChange', null)
            eventBus.$emit('closeDialog', null)
            //this.$router.push({name: 'Journal'})
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
          this.submitting = false
          this.$q.notify('Something Wrong.')
          console.log(e)
      }) 

    },
    loadData(){     
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getWork"
      this.form.IdWork = this.IdWork
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          if(response.status == 200){ 
            this.openWork = response.data 
            this.Starting = this.moment(response.data.Starting).format('YYYY-MM-DDTHH:mm:ss.sssZ') 
            this.Ending = this.moment(response.data.Ending).format('YYYY-MM-DDTHH:mm:ss.sssZ')
            if(response.data.IdWorkAssign == null){
              this.selectWork = response.data.IdResource
              this.selectGeofence = response.data.IdGeoRegion
              this.selectProduct = response.data.IdProduct
            }
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {        
        this.$q.notify('ERROR')      
        console.log(e);
      })
    },
    dateFormat(val) {
      return date.formatDate(val, this.$store.state.session.DateTimeFormat)
    },
    loadGeoRegions(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = 'GeoRegions'
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          var self = this;
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
              this.selectOptions = []   
              response.data.forEach(GeoRegion => {
                  this.selectOptions.push({label: GeoRegion.Description, value: GeoRegion.IdGeoRegion}) 
                  //this.geoRegion[GeoRegion.IdGeoRegion] = { geoRegionDescription: GeoRegion.Description }
              });
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
          this.submitting = false
          this.$q.notify('ERROR')
          console.log(e)
      })
    },
    loadWork(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = 'SelectWork'
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          var self = this;
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
            this.selectOptions = []   
            this.selectWorkOptions = response.data
          }
          else{
              this.$q.notify('ERROR')
          }
      })
      .catch(e => {
          this.submitting = false
          if(e.response.status == 403){
              //this.errors.push(this.translate('LoginError'))
              this.$q.notify('ERROR')

          }
          console.log(e)
      })
  },
  loadProduct(){
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.IdGeoRegion = this.selectGeofence
        this.form.action = "listProductByGeoRegion"
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            console.log(response)
            if(response.status == 200){ 
              this.optionsProduct = [] 
              this.optionsProduct.push({ value: 0, label: this.$t('global.All') })
              response.data.forEach(product => {
                this.optionsProduct.push(product)
              })
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {        
          this.$q.notify('Something Wrong.')      
          console.log(e);
        })
    },

  },
  
  created () {
      this.loadWork()
      this.loadGeoRegions()
      this.loadData()
      
  },
  watch: {
    IdWork: function (val) {
      this.loadData()
    },
    selectGeofence: function (newWork, oldWork) {
          //alert('load product')
          this.loadProduct()
    },
  },
  computed: {
    timeElapsed: function () {
      if(this.Ending == "Invalid date"){
        return ''
      }
      var seconds = date.getDateDiff(this.Ending, this.Starting, 'seconds')
      return Math.floor(this.moment.duration(seconds,'seconds').asHours()) + ':' + this.moment.duration(seconds,'seconds').minutes() + ':' + this.moment.duration(seconds,'seconds').seconds(); 
    },
  },
}

</script>
<style scoped>
.timer{
  text-align: center;
  padding-top: 10px;
}
</style>
